import { registerFragment } from "@cedarjs/web/apollo"

registerFragment(gql`
  fragment KnackeryFragment on Knackery {
    id
    createdAt
    profile {
      fullName
    }
    shrimpsDeadCount
    shrimpsDeadBiomass
    shrimpsDeadBiomassEstimated
    moults
    landingNetCount
    description
    extraFields
    
    idBatch
    idTank
    idWater
  }
`)

registerFragment(gql`
  fragment KnackeryEditFragment on Knackery {
    id
    createdAt
    createdBy
    shrimpsDeadCount
    shrimpsDeadBiomass
    shrimpsDeadBiomassEstimated
    moults
    landingNetCount
    description
    extraFields
    
    idBatch
    idTank
    idWater
  }
`)

registerFragment(gql`
  fragment KnackeryFormFragment on Query {
    tank(id:$idTank, date: $date) {
      id
      idSite
      name
      water {
        id
        name
      }
      
      lastBatchTransfer{
        batch {
          id
          idBatchInitial
          
          batchProductionForDate: batchProductionViewForDate {
            avgWeight
          }
        }
      }
    }
  }
`)